import Button from '../shared/Button';
import useTripStore from '../../context/TripStore';

const PlanToggle = () => {
  const { itinerary, setActivePlan } = useTripStore();
  const { activePlan } = itinerary;

  if (!itinerary.planA && !itinerary.planB) {
    return null;
  }

  return (
    <div className="flex gap-2 mb-6">
      <Button
        variant={activePlan === 'a' ? 'primary' : 'secondary'}
        onClick={() => setActivePlan('a')}
        disabled={!itinerary.planA}
      >
        {itinerary.planA?.title || 'Plan A (Realistic)'}
      </Button>
      <Button
        variant={activePlan === 'b' ? 'primary' : 'secondary'}
        onClick={() => setActivePlan('b')}
        disabled={!itinerary.planB}
      >
        {itinerary.planB?.title || 'Plan B (Ambitious)'}
      </Button>
    </div>
  );
};

export default PlanToggle;



